import { render, staticRenderFns } from "./SendEgiftPanelReviewFields.vue?vue&type=template&id=3331b316&scoped=true"
import script from "./SendEgiftPanelReviewFields.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelReviewFields.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelReviewFields.vue?vue&type=style&index=0&id=3331b316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3331b316",
  null
  
)

export default component.exports